import { Text } from "@ui-kitten/components";
import { resolveLogo } from "components/LoginContainer/utils";
import React from "react";
import { StyleSheet, View } from "react-native";

const SSOPlayerNotFound = () => {
  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <View style={styles.logoContainer}>
          {resolveLogo({ isDarkBackground: false })}
        </View>
        <Text category="h5" style={styles.title}>
          Account Not Found
        </Text>
        <Text category="p1" style={styles.message}>
          We could not find an account for you. Please contact your host for
          assistance.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f5f5f5",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
  },
  card: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 32,
    width: "100%",
    maxWidth: 480,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  logoContainer: {
    marginBottom: 24,
  },
  title: {
    marginBottom: 12,
    textAlign: "center",
  },
  message: {
    textAlign: "center",
    color: "#666",
    lineHeight: 24,
  },
});

export default SSOPlayerNotFound;
